import React from 'react';
import StatusBadge from '../StatusBadge';

export default function CouponStatusBadge({ coupon }) {
  if (coupon.deleted) {
    return <StatusBadge status="deleted" label="Deleted" />;
  }

  if (coupon.valid) {
    return <StatusBadge status="valid" label="Valid"></StatusBadge>;
  }

  return <StatusBadge status="expired" label="Expired"></StatusBadge>;
}
